export const STYLE_VARIANTS = {
  DARK: 'dark',
  LIGHT: 'light',
} as const;
